import React, { lazy, Suspense } from 'react';
import { useLoading } from './LoadingProvider';

// Use with components that don't need to be immediately visible
const LazyComponent = ({ component: Component, fallback, ...props }) => {
  const { deferredLoaded } = useLoading();
  
  return (
    <>
      {deferredLoaded ? (
        <Suspense fallback={fallback || <div>Loading...</div>}>
          <Component {...props} />
        </Suspense>
      ) : (
        fallback || <div>Loading...</div>
      )}
    </>
  );
};

export default LazyComponent;
